import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";

const CustomerLoadingView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState('');

  let customer_id = localStorage.getItem("customer_id");
  let season_id = localStorage.getItem("season_id");

  useEffect(() => {
    axios
      .get(`/customerportal/supply-chain-loading/view/${id+'-'+customer_id+'-'+season_id+'-portal_user'}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.supply_chain_loading);
          console.log(setCurrencySymbol);
          // axios.get(`/helper/currency-by-order/${response.data.data.supply_chain_loading.order_id}`, {
          //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          //   })
          //   .then((response) => {
          //     if (response.data.code === 200) {
          //     // console.log(response.data.data);
          //       setCurrencySymbol(response.data.data.customer_currency)
              
          //     }
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(value);

  const viewFile = (link) => {
    // Prevent the default behavior that causes page reload
    return (e) => {
      e.preventDefault();
      
      AWS.config.setPromisesDependency(); 
      AWS.config.update({
        accessKeyId: AWS_ACCESS_KEY_ID,
        secretAccessKey: AWS_SECRET_ACCESS_KEY,
        region: AWS_DEFAULT_REGION,
        signatureVersion: 'v4',
      });
    
      const s3 = new AWS.S3();
      const params = { Bucket: AWS_BUCKET, Key: link };
      const url = s3.getSignedUrl('getObject', params);
    
      // Create an anchor element and force a download
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.target = '_blank'; // Open in new tab
      anchor.download = link.split('/').pop(); // Suggest the file name for download
      document.body.appendChild(anchor); // Append to body
      anchor.click(); // Trigger the download
      document.body.removeChild(anchor); // Clean up
    };
  };

  return (
    <>
      <div className={`main-wrapper customer-portal-main ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">View Supply Chain Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/customerportal/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/loadings">
                      Supply Chain Loadings
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Supply Chain Loading
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Customer Loadings Details</h4>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th className="p-3">Order</th>
                          <td className="p-3">
                            {value.order_id ? value.order.po_number : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Location</th>
                          <td className="p-3">
                            {value.location_id ? value.location.title : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Transit  Supplier</th>
                          <td className="p-3">
                            {value.transitsupplier ? value.transitsupplier.name : ""}
                          </td>
                        </tr>
                        {/* <tr>
                          <th className="p-3">Transport Supplier</th>
                          <td className="p-3">
                            {value.transport_supplier_data ? value.transport_supplier_data.name : ""}
                          </td>
                        </tr> */}
                    
                        <tr>
                          <th className="p-3">Transport Cost</th>
                          <td className="p-3">{value.transport_cost}{currencySymbol}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Sous Dum</th>
                          <td className="p-3">{value.sous_dum}</td>
                        </tr>
                       <tr>
                      <th className="p-3">Temp Tale</th>
                      <td className="p-3">
                          {value.temp_tale && (value.temp_tale.startsWith('http://') || value.temp_tale.startsWith('https://')) ? (
                            <a target="_bank" href={value.temp_tale}>{value.temp_tale}</a>
                          ) : (
                            <span>{value.temp_tale}</span>
                          )}
                        </td>
                    </tr>
                        <tr>
                          <th className="p-3">Loading Status</th>
                          <td className="p-3">
                            {value.loading_status_id
                              ? value.location_status.title
                              : ""}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <h5 className="card-title">Supply Chain Loading Files</h5>

                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="p-3">File Name</th>
                          <th className="p-3">File Type</th>
                          <th className="p-3">File Link</th>
                          <th className="p-3">File Extension</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.loading_files &&
                          value.loading_files.map((item, indx) => (
                            <tr key={item.file_name || indx}>
                              <td className="p-3">{item.file_name}</td>
                              <td className="p-3">{item.file_type_name}</td>
                              <td className="p-3">
                                {item.link && (
                                  <a
                                    className="btn btn-primary"
                                    href="#"
                                    onClick={viewFile(item.link)}
                                  >
                                    Download
                                  </a>
                                )}
                              </td>
                              <td className="p-3">{item.extension}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerLoadingView;